import { DAY_NAMES_NARROW, DayNameNarrow } from '@/constants'
import { MarketShopBusinessHoursModel } from '@/models'

import { MarketShopBusinessHoursFormModel } from './market-shop-settings.types'

export const getDefaultBusinessHours = (): MarketShopBusinessHoursFormModel[] => [
  { enabled: false, endTime: 1200, name: 'Su', startTime: 480 },
  { enabled: true, endTime: 1200, name: 'Mo', startTime: 480 },
  { enabled: true, endTime: 1200, name: 'Tu', startTime: 480 },
  { enabled: true, endTime: 1200, name: 'We', startTime: 480 },
  { enabled: true, endTime: 1200, name: 'Th', startTime: 480 },
  { enabled: true, endTime: 1200, name: 'Fr', startTime: 480 },
  { enabled: false, endTime: 1200, name: 'Sa', startTime: 480 },
]

export const getDefaultTips = (): string[] => ['5', '10', '15']

// Note: Convert API business hours to form format (all 7 days with enabled flag)
export const apiBusinessHoursToForm = (
  apiHours: MarketShopBusinessHoursModel[],
): MarketShopBusinessHoursFormModel[] => {
  const enabledDays = new Map(apiHours.map((h) => [h.name, h]))

  return DAY_NAMES_NARROW.map((name) => {
    const apiDay = enabledDays.get(name)
    if (apiDay) {
      return {
        enabled: true,
        endTime: apiDay.endTime,
        name,
        startTime: apiDay.startTime,
      }
    }
    return {
      enabled: false,
      endTime: 1200,
      name,
      startTime: 480,
    }
  })
}

// Note: Convert form business hours to API format (only enabled days)
export const formBusinessHoursToApi = (
  formHours: Array<{
    enabled: boolean
    name: DayNameNarrow
    startTime?: number | null
    endTime?: number | null
  }>,
): MarketShopBusinessHoursModel[] => {
  return formHours
    .filter((h) => h.enabled && h.startTime != null && h.endTime != null)
    .map((h) => ({
      endTime: h.endTime as number,
      name: h.name,
      startTime: h.startTime as number,
    }))
}
